__turbopack_context__.v({
  "fade-in": "Spinner-module-scss-module__mGxLBG__fade-in",
  "no-transform": "Spinner-module-scss-module__mGxLBG__no-transform",
  "rotate": "Spinner-module-scss-module__mGxLBG__rotate",
  "spinner": "Spinner-module-scss-module__mGxLBG__spinner",
  "spinnerCenter": "Spinner-module-scss-module__mGxLBG__spinnerCenter",
  "spinnerSizeText": "Spinner-module-scss-module__mGxLBG__spinnerSizeText",
  "spinnerVariantInline": "Spinner-module-scss-module__mGxLBG__spinnerVariantInline",
});
